var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 64.6865C38.9279 64.6865 45.2114 62.7971 50.556 59.2574C55.9006 55.7176 60.0662 50.6865 62.5261 44.8001C64.9859 38.9137 65.6295 32.4364 64.3755 26.1875C63.1214 19.9385 60.0261 14.1985 55.4809 9.69323C50.9357 5.18798 45.1448 2.11981 38.8404 0.876817C32.5361 -0.36618 26.0013 0.271768 20.0627 2.70999C14.1241 5.14822 9.04836 9.27722 5.47722 14.5748C1.90608 19.8725 0 26.1008 0 32.4722C0 41.016 3.42409 49.2098 9.51902 55.2512C15.6139 61.2925 23.8804 64.6865 32.5 64.6865Z",
    fill: "#888EA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2406 18.0469H17.813V25.4092H25.2406V18.0469Z",
    fill: "#111D43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2406 28.7744H17.813V36.1367H25.2406V28.7744Z",
    fill: "#111D43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2406 39.5176H17.813V46.8799H25.2406V39.5176Z",
    fill: "#111D43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2137 18.0469H28.7861V25.4092H36.2137V18.0469Z",
    fill: "#111D43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2137 28.7744H28.7861V36.1367H36.2137V28.7744Z",
    fill: "#111D43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2137 39.5176H28.7861V46.8799H36.2137V39.5176Z",
    fill: "#111D43"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1703 18.0469H39.7427V25.4092H47.1703V18.0469Z",
    fill: "#111D43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1703 28.7744H39.7427V36.1367H47.1703V28.7744Z",
    fill: "#111D43"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1703 39.5176H39.7427V46.8799H47.1703V39.5176Z",
    fill: "#111D43"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnector);
export default __webpack_public_path__ + "static/media/connector.062b9c95e1de84db6f0fe42abcd633a2.svg";
export { ForwardRef as ReactComponent };